import { LocalizedUrl } from 'app/services/theme/theme.models';

/**
 * Picks the tenant URL for the language, then the tenant default. Without a tenant URL map or a language
 * the language's own URL is used. The fallback applies when nothing is set.
 */
export function resolveLocalizedUrl(
  localizedUrl: LocalizedUrl | null,
  languageKey: string | undefined,
  languageUrl: string | undefined,
  fallbackUrl: string,
): string {
  if (localizedUrl && languageKey) {
    return localizedUrl[languageKey] || localizedUrl.default || fallbackUrl;
  }
  return localizedUrl?.default || languageUrl || fallbackUrl;
}

/**
 * Sends users without a license to the licenses page and back to the administration once a license appears.
 * Returns null when no navigation is needed.
 */
export function getLicenseRedirect(previous: boolean | null, current: boolean | null, url: string): string[] | null {
  if (current === null) {
    return null;
  }
  const isOnLicensesPage: boolean = url.startsWith('/licenses');
  if (current === false && !isOnLicensesPage) {
    return ['/licenses'];
  }
  if (previous === false && current === true && isOnLicensesPage) {
    return ['/administration', 'licenses'];
  }
  return null;
}
